import React, { useEffect, useState } from "react";
import NavigationBanner from "../../components/common/NavigationBanner";
import SectionHeading from "../../components/user/NewHome/SectionHeading";
import axiosInstance from "../../utils/axios";
import BlogsGrid from "../../components/user/Blog/BlogsGrid";
import hand_rise_banner from "../../Assets/Images/hand_rise_banner.png";

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getBlogData = async () => {
      try {
        const response = await axiosInstance.get(`/blogs/all-blogs`);
        // console.log("Blogsdata:",response.data)
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };

    window.scrollTo({ top: 0, behavior: "smooth" });
    getBlogData();
  }, []);
  return (
    <div>
      <NavigationBanner title={"Blogs"} background={hand_rise_banner} />
      <div className="general-p-m flex flex-col justify-center mx-auto gap-10">
        <SectionHeading
          subtitle="Blogs & Events"
          title="exceptional case studies at a glance"
        />

        {loading ? (
          <p className="text-center text-gray-500">Loading blogs...</p>
        ) : blogs.length > 0 ? (
          <BlogsGrid blogs={blogs} />
        ) : (
          <p className="text-center text-gray-500">No blogs available</p>
        )}
      </div>
    </div>
  );
};

export default Blog;
